import { createFileRoute } from '@tanstack/react-router'
import { OrgAnalyticsScreen } from '@/components/analytics/org-analytics-screen'
import { DashboardSkeleton, ViewBarSkeleton } from '@/components/shell/screen-skeletons'
import { requireAnalyticsAccess } from '@/lib/queries/analytics-access'

/** The bare dashboard — the default lens, no saved view applied. */
export const Route = createFileRoute('/o/$org/analytics/')({
  beforeLoad: ({ context: { queryClient }, params: { org } }) =>
    requireAnalyticsAccess({ queryClient, orgSlug: org }),
  pendingComponent: () => (
    <>
      <ViewBarSkeleton />
      <DashboardSkeleton />
    </>
  ),
  component: OrgAnalyticsScreen,
})
